// Library Import
import { createSlice } from "@reduxjs/toolkit";

// Local Imports
import {
  addChallenge,
  getChallenge,
  deleteChallenge,
  updateChallenge,
} from "@thunks/adminthunk.js";
import { getTotalStudentCount, uploadFileData } from "../thunks/adminthunk";

export const adminSlice = createSlice({
  initialState: {
    loading: false,
    adminLoggedIn: JSON.parse(localStorage.getItem("adminLogin")) || false,
  },
  name: "adminslice",
  reducers: {
    redSetAdminLogin: (state, action) => {
      return { ...state, adminLoggedIn: true };
    },
    redResetAdminError: (state, action) => {
      return { ...state, error: null };
    },
    redResetChallengeDeleted: (state, action) => {
      return { ...state, challengeDeleted: null, challengeDetails: null };
    },
    redResetChallengeCreated: (state, action) => {
      return { ...state, challengeCreated: null };
    },
    redResetChallengeDetails: (state, action) => {
      return { ...state, challengeDetails: null };
    },
    redLogout: (state) => {
      localStorage.removeItem("adminLogin");
      return { ...state, adminLoggedIn: false };
    },
    redResetUserAdded: (state, action) => {
      return { ...state, userAdded: null, userFileAdded: null };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addChallenge.pending, (state) => {
      return { ...state, loading: true };
    });

    builder.addCase(addChallenge.fulfilled, (state, action) => {
      if (action.payload.err) {
        return {
          ...state,
          loading: false,
          error: action.payload.err,
          userToken: null,
        };
      } else {
        return {
          ...state,
          loading: false,
          error: null,
          ...action.payload,
        };
      }
    });

    builder.addCase(getChallenge.pending, (state) => {
      return { ...state, challengeDetailsLoading: true };
    });

    builder.addCase(getChallenge.fulfilled, (state, action) => {
      if (action.payload.err) {
        return {
          ...state,
          challengeDetailsLoading: false,
          error: action.payload.err,
          challengeDetails: null,
        };
      } else {
        return {
          ...state,
          challengeDetailsLoading: false,
          challengeDetails: action.payload,
          error: null,
        };
      }
    });

    builder.addCase(deleteChallenge.pending, (state) => {
      return { ...state, loading: true };
    });

    builder.addCase(deleteChallenge.fulfilled, (state, action) => {
      if (action.payload.err) {
        return {
          ...state,
          loading: false,
          error: action.payload.err,
          challengeDeleted: null,
        };
      } else {
        return {
          ...state,
          loading: false,
          challengeDeleted: action.payload.challengeDeleted,
          error: null,
        };
      }
    });

    builder.addCase(updateChallenge.pending, (state) => {
      return { ...state, loading: true };
    });

    builder.addCase(updateChallenge.fulfilled, (state, action) => {
      if (action.payload.err) {
        return {
          ...state,
          loading: false,
          error: action.payload.err,
          challengeDetails: null,
          updatedChallenge: null,
        };
      } else {
        return {
          ...state,
          loading: false,
          updatedChallenge: action.payload,
          challengeDetails: null,
          error: null,
        };
      }
    });

    builder.addCase(uploadFileData.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(uploadFileData.fulfilled, (state, action) => {
      if (action.payload.err) {
        return {
          ...state,
          loading: false,
          error: action.payload.err,
          userFileAdded: null,
        };
      } else {
        return {
          ...state,
          loading: false,
          userFileAdded: true,
          error: null,
        };
      }
    });

    builder.addCase(getTotalStudentCount.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(getTotalStudentCount.fulfilled, (state, action) => {
      if (action.payload.err) {
        return {
          ...state,
          loading: false,
          error: action.payload.err,
          totalStudents: null,
        };
      } else {
        return {
          ...state,
          loading: false,
          totalStudents: action.payload.totalUsers,
          error: null,
        };
      }
    });
  },
});

export const {
  redSetAdminLogin,
  redResetAdminError,
  redResetChallengeDeleted,
  redResetChallengeCreated,
  redResetChallengeDetails,
  redLogout,
  redResetUserAdded,
} = adminSlice.actions;
